import MPlaceholder from './Placeholder.vue';

export default MPlaceholder;
